module.exports = __webpack_public_path__ + "static/media/Bayartsogt.5fd2b869.jpg";